import type { StyleRule } from '@archipro-design/aria';
import { categorySelectorSlotClassNames, pxToRem } from '@archipro-design/aria';

export const CategorySelector: StyleRule<{ isRoot?: boolean }> = ({
    isRoot,
    theme,
}) => ({
    ...(isRoot && {
        [`& .${categorySelectorSlotClassNames.headerCategory}`]: {
            cursor: 'auto',
            [`&:hover`]: {
                textDecoration: 'unset',
            },
        },
    }),

    [theme.screen.laptop]: {
        [`& .${categorySelectorSlotClassNames.categoriesContainer} > :not(:last-child)`]:
            {
                marginBottom: pxToRem(10),
            },
    },
});
